<template>
  <v-app>
    <v-navigation-drawer v-model="controls.drawer" app>
      <v-layout align-center justify-center column class="pt-6 pb-4 grey lighten-4">
        <div class="app-logo-sheet">
          <v-img
            :src="require('@/assets/images/logo.png')"
            width="68px"
            height="64px"
            class="ma-6"
          ></v-img>
        </div>
        <div class="headline mt-4">Play My Audio</div>
        <div class="caption">Admin CMS</div>
      </v-layout>
      <v-list flat>
        <v-subheader>
          <div class="font-weight-bold grey--text mx-auto">NAVIGATION</div>
        </v-subheader>
        <template v-for="item in navItems">
          <v-list-item
            v-if="!item.children"
            link
            :key="item.label"
            :to="item.to"
            class="font-weight-bold"
          >
            <v-list-item-content>
              <v-list-item-title class="pa-2 app-nav--item">{{
                item.label
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-group v-else :key="item.label">
            <template v-slot:activator>
              <v-list-item-title class="pa-2 app-nav--item font-weight-bold">
                {{ item.label }}
              </v-list-item-title>
            </template>
            <v-list-item
              class="pl-8"
              v-for="child in item.children"
              :key="child.label"
              link
              :to="child.to"
            >
              <v-list-item-title class="pa-2 app-nav--item">
                {{ child.label }}
              </v-list-item-title>
            </v-list-item>
          </v-list-group>
        </template>
      </v-list>
      <template v-slot:append>
        <v-list>
          <v-menu top offset-y>
            <template v-slot:activator="{ on }">
              <v-list-item two-line v-on="on">
                <v-list-item-avatar>
                  <user-avatar size="40" :avatar="user.avatar" />
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title> {{ user.full_name }} </v-list-item-title>
                  <v-list-item-subtitle> {{ user.email ? user.email : user.phone_number }} </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </template>
            <v-list>
              <v-list-item :to="{name: 'user.details', params: {id: user.id}}"> <v-list-item-title>Profile</v-list-item-title> </v-list-item>
              <v-list-item> <v-list-item-title>Settings</v-list-item-title> </v-list-item>
              <v-list-item @click="logoutConfirmDialog = true"> <v-list-item-title>Log out</v-list-item-title> </v-list-item>
            </v-list>
          </v-menu>
        </v-list>
      </template>
    </v-navigation-drawer>
    <v-content>
      <v-container>
        <slot />
      </v-container>
    </v-content>
    <v-dialog v-model="logoutConfirmDialog" max-width="290">
      <v-card>
        <v-card-title class="headline">Logout</v-card-title>
        <v-card-text>
          <strong>Are you sure you want to logout ?</strong>
        </v-card-text>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn text @click="logoutConfirmDialog = false">
            Cancel
          </v-btn>
          <v-btn color="primary" text @click="logout">
            Logout
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import ControlsMixin from '@/utils/mixins/Controls'
import { mapState, mapActions, mapGetters } from 'vuex'
import UserAvatar from '@/components/UserAvatar'

export default {
  name: 'MainLayout',

  components: {
    UserAvatar
  },

  mixins: [ControlsMixin],

  data () {
    return {
      navItems: [
        { label: 'Inbox', to: { name: 'inbox' } },
        { label: 'Users', to: { name: 'users' } },
        { label: 'Audios', to: { name: 'audios' } },
        { label: 'Categories', to: { name: 'categories' } },
        { label: 'Comments', to: { name: 'comments' } },
        {
          label: 'Reports',
          children: [
            { label: 'Comment', to: { name: 'reports.comment' } }
          ]
        },
        { label: 'Settings', to: { name: 'settings' } }
        // { label: 'Content', to: { name: 'users' } },
        // { icon: mdiAccountGroup, label: 'Push Notifications', to: { name: 'users' } },
        // { icon: mdiAccountGroup, label: 'Settings', to: { name: 'users' } },
        // { icon: mdiAccountGroup, label: 'Reports', to: { name: 'users' } }
      ],
      logoutConfirmDialog: false
    }
  },

  computed: {
    ...mapState({
      user: state => state.auth.user
    }),
    ...mapGetters({
      avatarThumb: 'auth/avatarThumb'
    })
  },

  methods: {
    ...mapActions({
      logout: 'auth/logout'
    })
  }

}
</script>

<style>
  .app-logo-sheet {
    border-radius: 28px;
    box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);
  }
  .v-navigation-drawer__border {
    background-color: transparent !important;
  }
</style>
